import React from 'react';
import styles from '../../styles/ProgressIndicator.module.css';

/**
 * ProgressIndicator - Visual progress bar for multi-step flow
 * @param {number} currentStep - Current step number (1-indexed)
 * @param {number} totalSteps - Total number of steps
 * @param {string[]} stepLabels - Optional labels for each step
 */
const ProgressIndicator = ({ currentStep, totalSteps, stepLabels = [] }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className={styles.container}>
      {/* Step Counter */}
      <div className={styles.stepText}>
        Step {currentStep} of {totalSteps}
        {stepLabels[currentStep - 1] && (
          <span className={styles.stepLabel}>: {stepLabels[currentStep - 1]}</span>
        )}
      </div>

      {/* Progress Bar */}
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
          role="progressbar"
          aria-valuenow={currentStep}
          aria-valuemin={1}
          aria-valuemax={totalSteps}
          aria-label={`Step ${currentStep} of ${totalSteps}`}
        />
      </div>

      {/* Step Dots */}
      <div className={styles.stepDots}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const isActive = index === currentStep - 1;
          const isCompleted = index < currentStep - 1;

          return (
            <div
              key={index}
              className={`${styles.stepDot} ${
                isCompleted ? styles.stepDotCompleted : ''
              } ${isActive ? styles.stepDotActive : ''}`}
              aria-label={`Step ${index + 1}${
                isCompleted ? ' completed' : isActive ? ' in progress' : ' pending'
              }`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;

